// Het plan alleen lezen (blok 8): "Open plan" in Beheer › Plannen, en de link die je
// van een collega krijgt. Het adres bepaalt het: ?tab=plan&lees=<propositie>-<jaar>,
// met &versie=<id> voor een vaste versie. Wie dat opent, kan niets bewaren: de plan-tab
// leest de stand van de server (samen.ts), schrijft niet terug, en laat de knoppen om te
// verplaatsen, te kiezen of vast te stellen weg. De server staat schrijven toch al niet
// toe aan beheer of een meelezer; dit is de nette kant ervan op het scherm.

import { createContext, useContext } from "react";

import { leesParam } from "../../lib/adres";

export type LeesAdres = { propositie: string; jaar: number; versie: string | null };

const LEES = /^([a-z_]{1,64})-(\d{4})$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Staat het plan in dit adres als alleen-lezen geopend? */
export function leesAdres(): LeesAdres | null {
  const m = LEES.exec(leesParam("lees") ?? "");
  if (!m) return null;
  const versie = leesParam("versie");
  return { propositie: m[1]!, jaar: Number(m[2]), versie: versie && UUID.test(versie) ? versie : null };
}

/** De link voor een collega: de plan-tab alleen lezen, zonder wat jij net open hebt staan. */
export function leesLink(propositie: string, jaar: number, versie: string | null): string {
  const q = new URLSearchParams({ tab: "plan", lees: `${propositie}-${jaar}` });
  if (versie) q.set("versie", versie);
  return `${window.location.origin}${window.location.pathname}?${q.toString()}`;
}

/** Waar je zonder te wijzigen kijkt, wordt hier "waar" voor alles eronder. */
export const LeesCtx = createContext<boolean>(false);

export const useAlleenLezen = (): boolean => useContext(LeesCtx);

const DATUM = new Intl.DateTimeFormat("nl-NL", { day: "numeric", month: "long", year: "numeric" });

/** "Werksessie 1" -> "werksessie 1"; de zin zegt zelf waar de versie uit is. */
export function versieZin(naam: string, gemaakt: string): string {
  return `Vaste versie: na ${naam.charAt(0).toLowerCase()}${naam.slice(1)}, ${DATUM.format(new Date(gemaakt))}`;
}
